<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IgzgvJ/tc-custom/9781625846730.jpg?1702083702049" alt="This image is the cover for the book Haunted Carthage, Missouri, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Carthage, Missouri, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>Civil War Ghosts of Southwest Missouri</i> takes the paranormal pulse of this rustic city in the heart of the Ozarks.</b><br/>  <br/> A rich mixture of inexplicable history and eerie happenstance runs through the portion of the Ozark Plateau that Carthage has carved out for itself. Woodland cabins greet visitors with phantom hosts or vanish into the night entirely. Rumors tell of lost Spanish treasure caravans haunting the hills with the same persistence as the Confederate guerrillas who were run aground there. But the town itself isn’t immune from the encroachment of the supernatural; the drama of tragic death continues to find a stage in an opera house, a hospital, and an elegant residence. Lisa Livingston-Martin tracks down the fiercest and most fascinating specters from Carthage’s past.<br/>  <br/> Includes photos!<br/>  <br/> “According to the book <i>Haunted Carthage, Missouri</i> by Lisa Livingston-Martin, there have been many sightings and various paranormal events in and around Carthage.” —<i>The Joplin Globe</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Livingston-Martin
      </h2>
      
      <p class="authorDescription body article">Lisa Livingston-Martin is a lifelong resident of Missouri, living in Webb City with her children. She has practiced law in Southwest Missouri for more than 20 years, and has longstanding interests in history and the paranormal. She is the author of Civil War Ghosts of Southwest Missouri and Haunted Joplin, also published by The History Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42055694